




























































































































































































































































import MenuBooleanItem from "./MenuBooleanItem.vue";

import { Action, Getter } from "vuex-class";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    MenuBooleanItem
  }
})
export default class Menu extends Vue {
  @Action("windowOpen") private windowOpen: any;
  @Action("setProperty") private setProperty: any;
  @Action("doResetWindowLocate") private doResetWindowLocate: any;
  @Action("exportStart") private exportStart: any;
  @Action("addListObj") private addListObj: any;
  @Action("saveChatLogHtml") private saveChatLogHtml: any;
  @Getter("roomName") private roomName: any;
  @Getter("isModal") private isModal: any;
  @Getter("peerId") private peerId: any;
  @Getter("members") private members: any;
  @Getter("isRoomJoined") private isRoomJoined: any;

  private isConnectHover: boolean = false;
  private isSelecting: boolean = false;
  private currentMenu: string = "";

  menuClick(): void {
    this.isSelecting = !this.isSelecting;
  }

  isShow(this: any, ...props: any[]): any {
    return (
      this.isSelecting && props.filter(prop => prop === this.currentMenu)[0]
    );
  }

  menuHover(prop: string): void {
    this.currentMenu = prop;
  }

  hoverConnect(flg: boolean): void {
    this.isConnectHover = flg;
  }

  /** 部屋情報ボタン押下 */
  clickRoomInfo(): void {
    this.windowOpen("private.display.roomInfoWindow");
  }

  /** 共有メモボタン押下 */
  clickPublicMemo() {
    this.addListObj({
      propName: "publicMemo",
      kind: "publicMemo",
      targetList: [],
      title: "共有メモ",
      tabList: []
    });
  }

  /** ログアウトボタン押下 */
  clickLogOut(): void {
    location.href = location.href.replace(/\?.+$/, "");
  }

  /* --------------------
   * ファイル
   * ----------------- */
  /** セーブ */
  clickExport(): void {
    this.exportStart();
    this.menuClick();
  }

  /** ロード */
  clickImport(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "ロード",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** チャットログ保存 */
  clickChatLog(): void {
    this.saveChatLogHtml();
    this.menuClick();
  }

  /* --------------------
   * 表示
   * ----------------- */
  /** フォントサイズ調整 */
  clickSettingFontSize(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "フォントサイズ変更",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** ウィンドウ配置初期化 */
  clickResetWindowLocate(): void {
    this.doResetWindowLocate();
    this.menuClick();
  }

  /* --------------------
   * コマ
   * ----------------- */
  /** キャラクター追加 */
  clickAddCharacter(): void {
    this.windowOpen("private.display.addCharacterSettingWindow");
    this.menuClick();
  }

  /** 範囲追加 */
  clickAddRange(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "範囲追加",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** チット作成 */
  clickAddChit(): void {
    this.windowOpen("private.display.addChitWindow");
    this.menuClick();
  }

  /** 墓場 */
  clickGraveyard(): void {
    alert("「墓場」はプレイヤーボックス画面に統合されました。");
    this.menuClick();
  }

  /** キャラクター待合室 */
  clickWaitingRoom(): void {
    alert("「キャラクター待合室」はプレイヤーボックス画面に統合されました。");
    this.menuClick();
  }

  /* --------------------
   * マップ
   * ----------------- */
  /** マップ変更 */
  clickChangeMap(): void {
    this.windowOpen("private.display.editMapWindow");
    this.menuClick();
  }

  /** フロアタイル追加 */
  clickAddFloorTile(): void {
    this.windowOpen("private.display.addFloorTileWindow");
    this.menuClick();
  }

  /** マップマスク追加 */
  clickAddMapMask(): void {
    this.windowOpen("private.display.addMapMaskWindow");
    this.menuClick();
  }

  /** 簡易マップ作成 */
  clickCreateEasyMap(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "簡易マップ",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** マップ状態保存 */
  clickSaveMap(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "マップ保存",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** マップ切り替え */
  clickSwitchMap(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "マップ切り替え",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /* --------------------
   * 画像
   * ----------------- */
  /** ファイルアップローダー */
  clickFileUploader(): void {
    this.windowOpen("private.display.fileUploaderWindow");
    this.menuClick();
  }

  /** タグ編集 */
  clickTagEdit(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "画像タグ編集",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** 画像削除 */
  clickDeleteImage(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "画像削除",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /* --------------------
   * ヘルプ
   * ----------------- */
  /** ようこそ */
  clickWelcome(): void {
    this.windowOpen("private.display.welcomeWindow");
    this.menuClick();
  }

  /** バージョン */
  clickVersion(): void {
    this.windowOpen("private.display.versionWindow");
    this.menuClick();
  }

  /** マニュアル */
  clickManual(): void {
    this.setProperty({
      property: "private.display.unSupportWindow.title",
      value: "マニュアル",
      logOff: true
    });
    this.windowOpen("private.display.unSupportWindow");
    this.menuClick();
  }

  /** オフィシャルサイトへ */
  clickOfficialSite(): void {
    window.open("http://quoridorn.com/", "_blank");
    this.menuClick();
  }

  /* --------------------
   * デモ
   * ----------------- */
  /** 開発履歴 */
  clickDevHistory(): void {
    this.windowOpen("private.display.devLogWindow");
    this.menuClick();
  }

  /** 不具合の報告 */
  clickBufForm(): void {
    window.open("https://9224.teacup.com/quoridorn_bug/bbs", "_blank");
    this.menuClick();
  }

  get menuStyle(): any {
    const result: any = {};
    if (this.isModal) result.filter = "blur(3px)";
    return result;
  }

  get roomInfoTitle(): string {
    return this.isRoomJoined === true
      ? "メンバーの一覧を見たり、部屋の設定を変えることができますよ。"
      : "お部屋に入っていません。\n「接続」ボタンを押してお部屋を作りましょう！！";
  }

  get publicMemoTitle(): string {
    return this.isRoomJoined === true
      ? "メンバーに共有したいテキストはこちらにどうぞ"
      : "部屋に入る前から準備しておくのですね！？\nなんと準備の良いお方でしょう！";
  }

  get logoutTitle(): string {
    return this.isRoomJoined === true
      ? "この部屋から退室するのですか？"
      : "お部屋に入っていません。\n「接続」ボタンを押してお部屋を作りましょう！！";
  }
}
